import { Button } from '@com/_atoms/NewButton';
import NextImage from '@com/_core/NextImage';
import { routeList } from '@routes/routeList';
import { useRouter } from 'next/router';

const QuickOrderBanner = () => {
  const { push } = useRouter();

  return (
    <div className="px-4 mb-5 select-none">
      <div className="p-3 flex gap-1 flex-col shadow-fab items-center rounded-xl bg-surface-secondary gap-x-2">
        <div className="flex gap-y-[6px] w-full">
          <div className="w-14 h-14 min-w-14 min-h-14 flex items-center justify-start rounded-lg overflow-hidden">
            <NextImage
              alt="fast-order"
              src="/images/fast-order.svg"
              width={56}
              height={56}
              loading="eager"
            />
          </div>

          <div className="w-full flex flex-col">
            <span className="text-Label/Small text-content-primary">
              تحویل سریع دارو بدون نسخه
            </span>
            <span className="text-Body/xSmall text-content-secondary line-clamp-2">
              برای سفارش داروی بدون نسخه، روی ثبت درخواست کلیک کنید.
            </span>
          </div>
        </div>

        <Button
          className="w-full text-nowrap shadow-fab"
          size="small"
          variant="text"
          onClick={() => {
            void push(routeList?.QuickOrder);
          }}
        >
          ثبت درخواست
        </Button>
      </div>
    </div>
  );
};

export default QuickOrderBanner;
